import { type AnyAction } from "../../../redux/types";
import { type ThunkAction } from "redux-thunk";
import { type RootState } from "../../../redux/store";
import { prepareResetCarriageDetailsUpdates, sendUpdateToHybris, updateCsticsAction } from "../../Linear/redux/actions";
import { SubstepType } from "../../Linear/dtos";
import { sendCarriageDetailsReset } from "../api/sendCarriageDetailsReset";
import { KmatType } from "~/Configurators/Linear/getKmatType";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, AnyAction>;

export function resetCarriageDetails(): ThunkResult<void> {
  return (dispatch, getState) => {
    const state = getState();

    const linearState = state.linearConfigurator;
    const updates = linearState.kmats[KmatType.CARRIAGE]
      .map((kmat, index) => {
        return prepareResetCarriageDetailsUpdates(kmat, 1);
      })
      .flat();

    dispatch(updateCsticsAction(updates, SubstepType.ConfigureCarriage));
    dispatch(sendUpdateToHybris(sendCarriageDetailsReset));
  };
}
